import SEO from "@/components/SEO";
import { MaskedLines, Fade, Overline } from "@/components/Reveal";

const SECTIONS = [
  {
    title: "1. Who we are",
    body: [
      "Mosaicon Strategies is a boutique strategic communications, public affairs, community engagement and political consulting firm based in the Greater Toronto Area, Ontario, Canada. This Privacy Policy describes how we collect, use, disclose and protect personal information obtained through this website, in accordance with the Personal Information Protection and Electronic Documents Act (PIPEDA) and applicable Ontario privacy principles.",
    ],
  },
  {
    title: "2. Information we collect",
    body: [
      "When you submit our contact form, we collect the information you provide: your name, organization, email address, telephone number, area of interest and the contents of your message, together with your consent to be contacted.",
      "We also collect limited technical information automatically when you visit the site — such as your IP address and browser type — which is used for security, spam prevention and website performance purposes.",
    ],
  },
  {
    title: "3. How we use your information",
    body: [
      "We use personal information solely to respond to your inquiry, to communicate with you about a potential or active engagement, and to maintain appropriate business records. We do not use your information for marketing lists, and we do not sell, rent or trade personal information to third parties.",
    ],
  },
  {
    title: "4. Consent",
    body: [
      "By submitting the contact form and checking the consent box, you consent to Mosaicon Strategies contacting you regarding your inquiry. You may withdraw your consent at any time by contacting us at mku@mosaicons.ca, subject to legal or contractual restrictions.",
    ],
  },
  {
    title: "5. Disclosure of information",
    body: [
      "Personal information is not disclosed to third parties except where required to deliver a service you have requested (for example, trusted specialist partners working under confidentiality obligations), or where required or permitted by law.",
    ],
  },
  {
    title: "6. Retention and security",
    body: [
      "We retain personal information only as long as necessary to fulfil the purposes for which it was collected or as required by law. We apply reasonable administrative and technical safeguards to protect personal information against loss, unauthorized access or disclosure.",
    ],
  },
  {
    title: "7. Cookies and analytics",
    body: [
      "This website does not use advertising or tracking cookies. Any analytics used are limited to understanding aggregate site usage and improving the website experience.",
    ],
  },
  {
    title: "8. Your rights",
    body: [
      "You have the right to request access to the personal information we hold about you and to request that it be corrected if inaccurate. To make a request, contact us using the information below.",
    ],
  },
  {
    title: "9. Contact",
    body: [
      "Questions or requests regarding this Privacy Policy or your personal information may be directed to: Mosaicon Strategies, Greater Toronto Area, Ontario, Canada — mku@mosaicons.ca — 416.568.4178.",
    ],
  },
  {
    title: "10. Changes to this policy",
    body: [
      "We may update this Privacy Policy from time to time. The current version will always be posted on this page. Last updated: July 2026.",
    ],
  },
];

const Privacy = () => (
  <>
    <SEO
      title="Privacy Policy | Mosaicon Strategies"
      description="How Mosaicon Strategies collects, uses, discloses and protects personal information, in accordance with PIPEDA and applicable Ontario privacy principles."
    />
    <section className="max-w-3xl mx-auto px-6 py-20 md:py-28" data-testid="privacy-page">
      <Overline>Legal</Overline>
      <h1 className="mt-6 font-serif text-4xl md:text-6xl tracking-tighter text-ink" data-testid="privacy-heading">
        <MaskedLines delay={0.15} lines={["Privacy Policy"]} />
      </h1>
      <Fade delay={0.3}>
        <p className="mt-8 text-base leading-relaxed text-ink/70">
          Mosaicon Strategies respects your privacy. This policy explains our practices with respect to personal
          information collected through this website and our contact form.
        </p>
      </Fade>
      <div className="mt-14 space-y-12">
        {SECTIONS.map((s, i) => (
          <Fade key={s.title} delay={Math.min(i * 0.04, 0.2)}>
            <section data-testid={`privacy-section-${i + 1}`}>
              <h2 className="font-serif text-2xl tracking-tight text-ink">{s.title}</h2>
              <div className="mt-4 space-y-4">
                {s.body.map((p, j) => (
                  <p key={j} className="text-sm md:text-base leading-relaxed text-ink/70">{p}</p>
                ))}
              </div>
            </section>
          </Fade>
        ))}
      </div>
    </section>
  </>
);

export default Privacy;
